/**
 * Nested Elements JavaScript Support
 * 
 * 为嵌套元素组件提供前端 JavaScript 支持
 */

(function($) {
    'use strict';

    // 等待 Elementor 依赖加载
    function waitForElementor(callback, maxAttempts = 50) {
        let attempts = 0;
        
        function check() {
            attempts++;
            
            if (typeof elementorCommon !== 'undefined' && typeof elementorFrontend !== 'undefined') {
                callback();
            } else if (attempts < maxAttempts) {
                setTimeout(check, 100);
            }
        }
        
        check();
    }

    // 初始化函数
    function initializeNestedElements() {
        // 嵌套元素处理器类
        class NestedElementsHandler {
            constructor() {
                this.init();
            }

            init() {
                // 监听 Elementor 嵌套元素类型加载事件
                if (elementorCommon.elements && elementorCommon.elements.$window) {
                    elementorCommon.elements.$window.on('elementor/nested-element-type-loaded', this.onNestedElementTypeLoaded.bind(this));
                }

                // 监听 Elementor 前端初始化
                if (elementorFrontend.hooks) {
                    elementorFrontend.hooks.addAction('frontend/element_ready/widget', this.onElementReady.bind(this));
                }

                // DOM 准备就绪时初始化
                $(document).ready(this.onDocumentReady.bind(this));
            }

            onNestedElementTypeLoaded() {
                this.initializeNestedElements();
            }

            onElementReady($element) {
                const widgetType = $element.data('widget_type');
                
                if (widgetType === 'simple-nested-demo.default') {
                    this.initSimpleNestedDemo($element);
                } else if (widgetType === 'hierarchical_menu.default') {
                    this.initHierarchicalMenu($element);
                }
            }

            onDocumentReady() {
                this.initializeNestedElements();
            }

            initializeNestedElements() {
                // 初始化所有嵌套元素
                $('.e-n-simple-demo').each((_, element) => {
                    this.initSimpleNestedDemo($(element));
                });

                $('.hierarchical-menu').each((_, element) => {
                    this.initHierarchicalMenu($(element));
                });
            }

            initSimpleNestedDemo($element) {
                // 确保容器正确设置
                $element.find('.e-n-simple-demo-item-content').each(function() {
                    const $content = $(this);
                    
                    // 添加拖拽提示
                    if ($content.children().length === 0) {
                        $content.addClass('empty-container');
                    }
                    
                    // 监听内容变化
                    const observer = new MutationObserver(() => {
                        if ($content.children().length > 0) {
                            $content.removeClass('empty-container');
                        } else {
                            $content.addClass('empty-container');
                        }
                    });
                    
                    observer.observe($content[0], {
                        childList: true,
                        subtree: true
                    });
                });
            }

            initHierarchicalMenu($element) {
                const $menu = $element.find('.hierarchical-menu');
                const $mainLayer = $menu.find('.hierarchical-menu__main-layer');
                const $submenuLayers = $menu.find('.hierarchical-menu__submenu-layer');
                
                // 处理箭头点击事件
                $menu.on('click', '.hierarchical-menu__arrow', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const submenuIndex = $(this).data('submenu-index');
                    const $targetLayer = $submenuLayers.filter(`[data-submenu-index="${submenuIndex}"]`);
                    
                    if ($targetLayer.length) {
                        // 隐藏主菜单
                        $mainLayer.addClass('slide-out');
                        
                        // 显示子菜单
                        setTimeout(() => {
                            $targetLayer.addClass('active');
                        }, 150);
                    }
                });
                
                // 处理返回按钮点击事件
                $menu.on('click', '.hierarchical-menu__back', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const $currentLayer = $(this).closest('.hierarchical-menu__submenu-layer');
                    
                    // 隐藏当前子菜单
                    $currentLayer.removeClass('active');
                    
                    // 显示主菜单
                    setTimeout(() => {
                        $mainLayer.removeClass('slide-out');
                    }, 150);
                });
                
                // 处理关闭按钮点击事件
                $menu.on('click', '.hierarchical-menu__close', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // 重置所有层级
                    $submenuLayers.removeClass('active');
                    $mainLayer.removeClass('slide-out');
                });
                
                // 动画支持
                const enableAnimation = $menu.data('enable-animation');
                const animationDelay = $menu.data('animation-delay') || 100;
                
                if (enableAnimation === 'yes') {
                    $menu.find('.hierarchical-menu__item').each(function(index) {
                        $(this).css('animation-delay', (index * animationDelay) + 'ms');
                    });
                }
            }
        }

        // 初始化嵌套元素处理器
        new NestedElementsHandler();

        // 导出到全局作用域（如果需要）
        window.NestedElementsHandler = NestedElementsHandler;
    }

    // 等待 Elementor 加载完成后初始化
    waitForElementor(initializeNestedElements);

})(jQuery);